const useA11yStore = defineStore('a11y', () => {
  const enabled = useCookie('a11n-enabled');
  const fontSizeMode = ref<'100' | '120' | '200'>('120');

  const toggleA11y = () => {
    const root = document.documentElement;
    if (enabled.value) {
      setFontSizeMode('100');

      root.style.setProperty('--image-filter', 'none');
    } else {
      setFontSizeMode('120');

      root.style.setProperty('--image-filter', 'grayscale(100%)');
    }

    enabled.value = enabled.value ? undefined : '1';
  };

  const setFontSizeMode = (mode: '100' | '120' | '200') => {
    fontSizeMode.value = mode;
    const coefByFontMode = {
      '100': 1,
      '120': 1.2,
      '200': 2,
    };

    const root = document.documentElement;

    root.style.setProperty(
      '--font-size-coef',
      coefByFontMode[fontSizeMode.value].toString(),
    );
  };

  return {
    enabled,
    fontSizeMode,
    toggleA11y,
    setFontSizeMode,
  };
});

export default useA11yStore;
